<div class="monestary">
    <!-- Show an error message if there is one -->
    <div *ngIf="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>
  
    <!-- If no error, display the retrieved content -->
    <div *ngIf="!errorMessage">
      <div [innerHTML]="safeContent"></div>
    </div>
  </div>
  <br />

  <a routerLink="dashboard" class="btn btn-sm btn-secondary">
    Take me Back
  </a>